import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

function WeeklyAttendance(props) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gender, setGender] = useState("");
  const [reportType, setReportType] = useState("roster");
  const [status, setStatus] = useState("NOT RECEIVED");
  const [header, setHeader] = useState([]);
  const tableRef = React.createRef();
  const [isExportReady, setIsExportReady] = useState(false);
  useEffect(() => {
    if (props.gender !== gender) {
      setGender(props.gender);
    }
    if (props.reportType !== reportType) {
      setReportType(props.reportType);
    }
  }, [props, gender, reportType]);
  useEffect(() => {
    console.log("Scrolling to table");
    if (tableRef.current) {
      console.log({ tableRef });
      setIsExportReady(true);
      //tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [tableRef]);
  useEffect(() => {
    if (props.status !== status) {
      setStatus(props.status);
    }
  }, [props.status]);

  useEffect(() => {
    if (gender === "" || gender === "") {
      return;
    }

    setLoading(true);
    var payload = {
      gender: gender,
    };
    if (reportType === "training") {
      payload.reportType = "training";
    }
    axios
      .post(
        "https://a9s48sduha.execute-api.ap-northeast-1.amazonaws.com/v1/weekly/sewadar/reporting",
        payload
      )
      .then((response) => {
        if (response.data.status === "success") {
          setData(JSON.parse(response.data.body).sewadarDetails);
        } else {
          alert(JSON.parse(response.data.body).message);
          setData([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [gender, reportType]);

  useEffect(() => {
    if (data.length > 0) {
      setHeader(Object.keys(data[0]));
    }
  }, [data]);

  const headingMap = {
    M: "Gents Sewadar Reported",
    F: "Ladies Sewadar Reported",
    training: "Training Sewadar Reported",
  };

  return (
    <>
      <div className="grid grid-cols-12 gap-5 printable">
        <div className="page-title">
          {reportType === "roster"
            ? headingMap[gender]
            : headingMap[reportType]}
        </div>
        <div className="text-lg uppercase col-span-12">
          {/* Time in HH:MM */}
          Date: {new Date().toLocaleDateString()} &nbsp; Time:{" "}
          {new Date().toLocaleTimeString()}
        </div>
        {loading && <div className="col-span-12">Loading...</div>}
        {!loading && data && data.length > 0 && header && header.length > 0 && (
          <>
            <div className="col-span-12 text-right skipprint">
              {isExportReady && (
                <ReactHTMLTableToExcel
                  filename={headingMap[gender]}
                  sheet={headingMap[gender]}
                  table="table1"
                  buttonText="  Excel"
                  className="fas fa-download text-green-600"
                >
                  <button>
                    <img
                      src="/images/icons/excel.png"
                      alt="Excel"
                      className="h-5 w-5 cursor-pointer"
                    />{" "}
                  </button>
                </ReactHTMLTableToExcel>
              )}
            </div>
            <table
              className="table-auto col-span-12 border-collapse"
              id="table1"
              ref={tableRef}
            >
              <thead>
                <tr>
                  <th className="border px-4 py-2">S.No.</th>
                  {header.map((item) => {
                    return (
                      <th className="border px-4 py-2" key={item}>
                        {item}
                      </th>
                    );
                  })}
                  <th className="border px-4 py-2">Checked</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => {
                  return (
                    <tr>
                      <td className="border text px-4 py-2">{index + 1}</td>

                      {header.map((key, index) => {
                        return (
                          <td className="border text px-4 py-2" key={index}>
                            {item[key]}
                          </td>
                        );
                      })}
                      <td className="border text px-4 py-2">&nbsp;</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        )}
      </div>
    </>
  );
}
export default WeeklyAttendance;
